import { RFMConfig } from "../api/UserApi";

export const RFM_DEFAULT: RFMConfig = {
  numberOfDivisions: 4,
  recency: [15552000000, 7776000000, 5184000000, 2592000000],
  monetary: [100, 500, 1000, 10000],
  frequency: [1, 2, 3, 5],
};
